// extracted by mini-css-extract-plugin
export default {"css-1i1mpo0":"_error_css-1i1mpo0__zOOiH","next-error-h1":"_error_next-error-h1__dsvmT"};